import { lazy } from "react";
import ChangePassword from "../pages/ChangePassword";
import AssignBoat from "../pages/AssignBoat";
import AssignDock from "../pages/AssignDock";
import TechnicianDetail from "../pages/TechnicianDetail";
import SupplierDetail from "../pages/SupplierDetail";
import AddSupplier from "../pages/AddSupplier";
import AddTechnician from "../pages/AddTechnician";
import EditTechnician from "../pages/EditTechnician";
import Analytics from "../pages/Analytics";
import PartUsage from "../pages/PartUsage";
import Customers from "../pages/Customers";
import CustomerDetail from "../pages/CustomerDetail";
import JobManagement from "../pages/JobManagement";
import JobDetail from "../pages/JobDetail";
import MaintenanceDetails from "../pages/MaintenanceDetails";
import CreateMaintenance from "../pages/CreateMaintenance";
import ManageServicePresets from "../pages/ManageServicePresets";
import CustomerRequests from "../pages/CustomerRequests";
import Quotes from "../pages/Quotes";
import CustomerRequestDetail from "../pages/CustomerRequestDetail";
import CreateQuote from "../pages/CreateQuote";
import QuotesDetail from "../pages/QuotesDetail";

const Home = lazy(() => import("../pages/Home"));
const Invoice = lazy(() => import("../pages/Invoice"));
const AllBoats = lazy(() => import("../pages/AllBoats"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const BoatInQue = lazy(() => import("../pages/BoatInQue"));
const BoatDocks = lazy(() => import("../pages/BoatDocks"));
const JobService = lazy(() => import("../pages/JobService"));
const CreateBoat = lazy(() => import("../pages/CreateBoat"));
const TaskReview = lazy(() => import("../pages/TaskReview"));
const ShowTimeLog = lazy(() => import("../pages/ShowTimeLog"));
const CreateStaff = lazy(() => import("../pages/Technicians"));
const DockDetails = lazy(() => import("../pages/DockDetails"));
const AddNewDocks = lazy(() => import("../pages/AddNewDocks"));
const AllInvoices = lazy(() => import("../pages/AllInvoices"));
const AllSupplier = lazy(() => import("../pages/AllSupplier"));
const BoatDetails = lazy(() => import("../pages/BoatDetails"));
const BoatTracker = lazy(() => import("../pages/BoatTracker"));
const TodayInvoice = lazy(() => import("../pages/TodayInvoice"));
const TodayService = lazy(() => import("../pages/TodayService"));
const UpdateDocsks = lazy(() => import("../pages/UpdateDocsks"));
const Subscription = lazy(() => import("../pages/Subscription"));
const LeadReceived = lazy(() => import("../pages/LeadReceived"));
const Notification = lazy(() => import("../pages/Notification"));
const CdsJobService = lazy(() => import("../pages/CdsJobService"));
const MentenanceTask = lazy(() => import("../pages/MentenanceTask"));
const ReviewSchedule = lazy(() => import("../pages/ReviewSchedule"));
const TaskDescription = lazy(() => import("../pages/TaskDescription"));
const InvoiceDataList = lazy(() => import("../pages/InvoiceDataList"));
const InvoicedDetails = lazy(() => import("../pages/InvoicedDetails"));
const MaintainedBoats = lazy(() => import("../pages/MaintainedBoats"));
const BusinessProfile = lazy(() => import("../pages/BusinessProfile"));
const GenerateInvoice = lazy(() => import("../pages/GenerateInvoice"));
const UpdateBoatDetails = lazy(() => import("../pages/UpdateBoatDetails"));
const StaffProductivity = lazy(() => import("../pages/StaffProductivity"));
const FailedToConnectXero = lazy(() => import("../pages/FailedToConnectXero"));

const ScheduledMaintenance = lazy(
  () => import("../pages/ScheduledMaintenance "),
);
const SuccessToConnectXero = lazy(
  () => import("../pages/SuccessToConnectXero"),
);
const TomorrowScheduledTask = lazy(
  () => import("../pages/TomorrowScheduledTask"),
);
const UpdateBusinessProfile = lazy(
  () => import("../pages/UpdateBusinessProfile"),
);

export const pageRoutes = {
  landingpage: "/",
  dashboard: "/dashboard",
  page_not_found: "*",
  login: "/login",
  signup: "/signup",
  forgot_password: "/forgot-password",
  boat_docks: "/docks",
  update_docks: "/update-docks",
  add_new_docks: "/add-new-docks",
  quick_lead: "/quick-lead",
  crate_boat: "/create-boat",
  AssignBoat: "/assign-boat",
  AssignDock: "/assign-dock",
  maintenance: "/maintenance-task",
  MaintenanceDetails: "/maintenance-details",
  CreateMaintenance: "/create-maintenance",
  ManageServicePresets: "/manage-service-presets",
  generate_invoice: "/generate-invoice",
  maintained_boats: "/maintained-boats",
  all_boats: "/all-boats",
  boat_detail: "/boat-detail",
  all_supplier: "/all-supplier",
  SupplierDetail: "/supplier-details",
  AddSupplier: "/add-supplier",
  technicians: "/all-technician",
  TechnicianDetail: "/technician-details",
  AddTechnician: "/add-technician",
  EditTechnician: "/edit-technician",
  review_schedule: "/review-schedule",
  business_profile: "/business-profile",

  update_business_profile: "/update-business-profile",
  job_service: "/job-service",
  mentenance_task: '/complete-maintenance-task',
  JobManagement: '/job-management',
  JobDetail: '/job-details',
  boat_tracer: "/boat-tracker",
  task_description: "/task-description",
  scheduled_boat: "/scheduled-boat",
  today_service: "/today-service",
  staff_productivity: "/staff-productivity",
  task_review: "/task-review",
  invoice: "/invoice",
  today_invoice: "/todays-invoice",
  dock_details: "/dock-details",
  update_boat: "/update-boat",
  tomorrow_scheduled_task: "/tomorrow-scheduled-task",
  cds_job_service: "/cds-job-service",
  notification: "/notification",
  all_invoice: "/all-invoice",
  invoice_detail: "/invoice-detail",
  invoice_list_data: "/invoice-list",
  subscription: "/subscription",
  Analytics: "/analytics",

  PartUsage: "/part-usage",
  Customers: "/customers",
  CustomerDetail: "/customer-detail",
  failed_to_connect_xero: "/failed-to-connect-xero",
  connected_to_xero: "/connected-to-xero",
  show_time_log: "/time-logs",
  // home: "/home",
  changePassword: "/change-password",


  // new pages
  CustomerRequests: "/customer-requests",
  quotes: "/quotes",
  CustomerRequestDetail: "/customer-request-detail",
  QuotesDetail: "/quotes-detail",
  CreateQuote: "/create-quote",
  terms_and_conditions: "/terms-and-conditions",
  privacy_policy: "/privacy-policy",
  acceptable_use_policy: "/acceptable-use-policy"
};



export const AllRoutes = [

  {
    name: "Dashboard",
    path: pageRoutes.dashboard,
    element: <Dashboard />,
    isPrivate: true,
  },
  {
    name: "Show Time Log",
    path: pageRoutes.show_time_log,
    element: <ShowTimeLog />,
    isPrivate: true,
  },
  // {
  //   name: "Home",
  //   path: pageRoutes.home,
  //   element: <Home />,
  //   isPrivate: false,
  // },
  {
    name: "Invoice List",
    path: pageRoutes.invoice_list_data,
    element: <InvoiceDataList />,
    isPrivate: true,
  },
  {
    name: "Analytics",
    path: pageRoutes.Analytics,
    element: <Analytics />,
    isPrivate: true,
  },


  {
    name: "PartUsage",
    path: pageRoutes.PartUsage,
    element: <PartUsage />,
    isPrivate: true,
  },
  {
    name: "Customers",
    path: pageRoutes.Customers,
    element: <Customers />,
    isPrivate: true,
  },
  {
    name: "CustomerDetail",
    path: pageRoutes.CustomerDetail,
    element: <CustomerDetail />,
    isPrivate: true,
  },
  {
    name: "Subscription",
    path: pageRoutes.subscription,
    element: <Subscription />,
    isPrivate: true,
  },
  {
    name: "Invoiced Details",
    path: pageRoutes.invoice_detail,
    element: <InvoicedDetails />,
    isPrivate: true,
  },
  {
    name: "Scheduled Boat",
    path: pageRoutes.scheduled_boat,
    element: <BoatInQue />,
    isPrivate: true,
  },
  {
    name: "Today Service",
    path: pageRoutes.today_service,
    element: <TodayService />,
    isPrivate: true,
  },
  {
    name: "Task Review",
    path: pageRoutes.task_review,
    element: <TaskReview />,
    isPrivate: true,
  },
  {
    name: "Dock Details",
    path: pageRoutes.dock_details,
    element: <DockDetails />,
    isPrivate: true,
  },
  {
    name: "Todays Invoice",
    path: pageRoutes.today_invoice,
    element: <TodayInvoice />,
    isPrivate: true,
  },
  {
    name: "Invoice",
    path: pageRoutes.invoice,
    element: <Invoice />,
    isPrivate: true,
  },
  {
    name: "All Invoice",
    path: pageRoutes.all_invoice,
    element: <AllInvoices />,
    isPrivate: true,
  },
  {
    name: "Staff Productivity",
    path: pageRoutes.staff_productivity,
    element: <StaffProductivity />,
    isPrivate: true,
  },
  {
    name: "BoatDocks",
    path: pageRoutes.boat_docks,
    element: <BoatDocks />,
    isPrivate: true,
  },
  {
    name: "AssignBoat",
    path: pageRoutes.AssignBoat,
    element: <AssignBoat />,
    isPrivate: true,
  },
  {
    name: "AssignDock",
    path: pageRoutes.AssignDock,
    element: <AssignDock />,
    isPrivate: true,
  },
  {
    name: "UpdateDocks",
    path: pageRoutes.update_docks,
    element: <UpdateDocsks />,
    isPrivate: true,
  },
  {
    name: "AddNewDocks",
    path: pageRoutes.add_new_docks,
    element: <AddNewDocks />,
    isPrivate: true,
  },
  {
    name: "LeadReceived",
    path: pageRoutes.quick_lead,
    element: <LeadReceived />,
    isPrivate: true,
  },
  {
    name: "CreateBoat",
    path: pageRoutes.crate_boat,
    element: <CreateBoat />,
    isPrivate: true,
  },
  {
    name: "ScheduledMaintenance",
    path: pageRoutes.maintenance,
    element: <ScheduledMaintenance />,
    isPrivate: true,
  },
  {
    name: "MaintenanceDetails",
    path: pageRoutes.MaintenanceDetails,
    element: <MaintenanceDetails />,
    isPrivate: true,
  },
  {
    name: "CreateMaintenance",
    path: pageRoutes.CreateMaintenance,
    element: <CreateMaintenance />,
    isPrivate: true,
  },
  {
    name: "ManageServicePresets",
    path: pageRoutes.ManageServicePresets,
    element: <ManageServicePresets />,
    isPrivate: true,
  },
  {
    name: "GenerateInvoice",
    path: pageRoutes.generate_invoice,
    element: <GenerateInvoice />,
    isPrivate: true,
  },
  {
    name: "MaintainedBoats",
    path: pageRoutes.maintained_boats,
    element: <MaintainedBoats />,
    isPrivate: true,
  },
  {
    name: "ListOfBoats",
    path: pageRoutes.all_boats,
    element: <AllBoats />,
    isPrivate: true,
  },
  {
    name: "BoatDetails",
    path: pageRoutes.boat_detail,
    element: <BoatDetails />,
    isPrivate: true,
  },
  {
    name: "UpdateBoatDetails",
    path: pageRoutes.update_boat,
    element: <UpdateBoatDetails />,
    isPrivate: true,
  },
  {
    name: "AllSupplier",
    path: pageRoutes.all_supplier,
    element: <AllSupplier />,
    isPrivate: true,
  },
  {
    name: "SupplierDetail",
    path: pageRoutes.SupplierDetail,
    element: <SupplierDetail />,
    isPrivate: true,
  },
  {
    name: "AddSupplier",
    path: pageRoutes.AddSupplier,
    element: <AddSupplier />,
    isPrivate: true,
  },
  {
    name: "CreateStaff",
    path: pageRoutes.technicians,
    element: <CreateStaff />,
    isPrivate: true,
  },
  {
    name: "TechnicianDetail",
    path: pageRoutes.TechnicianDetail,
    element: <TechnicianDetail />,
    isPrivate: true,
  },
  {
    name: "AddTechnician",
    path: pageRoutes.AddTechnician,
    element: <AddTechnician />,
    isPrivate: true,
  },
  {
    name: "EditTechnician",
    path: pageRoutes.EditTechnician,
    element: <EditTechnician />,
    isPrivate: true,
  },
  {
    name: "ReviewSchedule",
    path: pageRoutes.review_schedule,
    element: <ReviewSchedule />,
    isPrivate: true,
  },
  {
    name: "BusinessProfile",
    path: pageRoutes.business_profile,
    element: <BusinessProfile />,
    isPrivate: true,
  },
  {
    name: "UpdateBusinessProfile",
    path: pageRoutes.update_business_profile,
    element: <UpdateBusinessProfile />,
    isPrivate: true,
  },
  {
    name: "CdsJobService",
    path: pageRoutes.job_service,
    element: <JobService />,
    isPrivate: true,
  },
  {
    name: "MentenanceTask",
    path: pageRoutes.mentenance_task,
    element: <MentenanceTask />,
    isPrivate: true,
  },
  {
    name: "JobManagement",
    path: pageRoutes.JobManagement,
    element: <JobManagement />,
    isPrivate: true,
  },
  {
    name: "JobDetail",
    path: pageRoutes.JobDetail,
    element: <JobDetail />,
    isPrivate: true,
  },
  {
    name: "BoatTracker",
    path: pageRoutes.boat_tracer,
    element: <BoatTracker />,
    isPrivate: true,
  },
  {
    name: "TaskDescription",
    path: pageRoutes.task_description,
    element: <TaskDescription />,
    isPrivate: true,
  },
  {
    name: "TomorrowScheduledTask",
    path: pageRoutes.tomorrow_scheduled_task,
    element: <TomorrowScheduledTask />,
    isPrivate: true,
  },
  {
    name: "CdsJob_Srvice",
    path: pageRoutes.cds_job_service,
    element: <CdsJobService />,
    isPrivate: true,
  },
  {
    name: "Notification",
    path: pageRoutes.notification,
    element: <Notification />,
    isPrivate: true,
  },
  {
    name: "Failed To Connect Xero",
    path: pageRoutes.failed_to_connect_xero,
    element: <FailedToConnectXero />,
    isPrivate: true,
  },
  {
    name: "Success To Connect Xero",
    path: pageRoutes.connected_to_xero,
    element: <SuccessToConnectXero />,
    isPrivate: true,
  },
  {
    name: "Change Password",
    path: pageRoutes.changePassword,
    element: <ChangePassword />,
    isPrivate: true,
  },

  // 
  {
    name: "Quotes",
    path: pageRoutes.quotes,
    element: <Quotes />,
    isPrivate: true,
  },
  {
    name: "Customer Requests",
    path: pageRoutes.CustomerRequests,
    element: <CustomerRequests />,
    isPrivate: true,
  },
  {
    name: "Customer Request Detail",
    path: pageRoutes.CustomerRequestDetail,
    element: <CustomerRequestDetail />,
    isPrivate: true,
  },
  {
    name: "Create Quote",
    path: pageRoutes.CreateQuote,
    element: <CreateQuote />,
    isPrivate: true,
  },
  {
    name: "Quotes Detail",
    path: pageRoutes.QuotesDetail,
    element: <QuotesDetail />,
    isPrivate: true,
  },
];
